import { asyncAction } from 'lib/actions';

export const rtvValueListFetchAction = asyncAction('rtvValueListPage/LIST_FETCH');
export const rtvValueListAppendPageAction = asyncAction('rtvValueListPage/LIST_APPEND_PAGE');
export const downloadRtvPdfAction = asyncAction('rtvValueListPage/DOWNLOAD_PDF');
